const defaultState = '';

export function pageTypeSourceReducer(state: string = defaultState) {
  return state;
}
